import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Explore from "./pages/Explore";
import Blog from "./pages/Blog";
import ContactUs from "./pages/ContactUs";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import PasswordChange from "./pages/PasswordChange";
import ForcePasswordChange from "./pages/ForcePasswordChange";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Navigate } from "react-router-dom";

const App = () => (
  <AuthProvider>
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} /> {/* Home page */}
          <Route path="/explore" element={<Explore />} /> {/* Explore page */}
          <Route path="/blog" element={<Blog />} /> {/* Blog page */}
          <Route path="/contact-us" element={<ContactUs />} /> {/* Contact page */}
          <Route path="/login" element={<Login />} /> {/* Login page */}

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/force-password-change" element={<ForcePasswordChange />} />
          <Route path="/password-change" element={<PasswordChange />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* Redirect all other routes to the home page */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </Router>
  </AuthProvider>
);

export default App;
